<template>
    <div class="tree-nodeitem" v-show="show" :data-show="show" :data-open="open" :data-itemid="treeNode.id">
        <div
            class="tree-item"
            @click="select"
            :class="{ 'tree-item-match': !!match, selected: !!selected }"
            :style="{ 'padding-left': (treeNode.level - 1) * 20 + 'px' }"
        >
            <span class="tree-toggle" @click="stopImmediatePropagation">
                <b class="tree-itemarrow" :class="{ open: open, leaf: treeNode.leaf }" @click="toggle"></b>
            </span>
            <label class="tree-itemcheckbox" v-show="hasCheckbox(el)">
                <input type="checkbox" :checked="checked === 2" @click="setChecked" />
                <span :data-checktype="checked"></span>
            </label>
            <el-tooltip class="item" effect="dark" content="货架已停用" placement="right" v-if="hasIcon(el)">
                <a class="tree-itemname-icon" :class="{ 'el-icon-warning': hasIcon(el) }" :title="treeNode.parsedName || treeNode.name">{{
                    treeNode.parsedName || treeNode.name
                }}</a>
            </el-tooltip>
            <a class="tree-itemname" :class="{ 'el-icon-warning': hasIcon(el) }" :title="treeNode.parsedName || treeNode.name" v-else>{{
                treeNode.parsedName || treeNode.name
            }}</a>
            <span class="tree-hovercont" v-show="hasControls(el)">
                <el-button
                    :key="index"
                    :type="(controlStyle && controlStyle.type) || ''"
                    :size="(controlStyle && controlStyle.size) || ''"
                    v-for="(control, index) in controls"
                    v-if="control.show ? control.show(treeNode) : true"
                    @click="toControl(control.handler, $event)"
                    >{{ control.text }}</el-button
                >
            </span>
        </div>
        <div v-show="open" class="tree-childlist">
            <tree-node
                ref="childNodes"
                v-for="(node, index) in treeNode.children"
                :treeNode="node"
                :api="api"
                :hasCheckbox="hasCheckbox"
                :hasIcon="hasIcon"
                :hasControls="hasControls"
                :hasSingleSelect="hasSingleSelect"
                :hasCascadeSelect="hasCascadeSelect"
                :controls="controls"
                :control-style="controlStyle"
                :key="index"
            ></tree-node>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tree-node',
    props: ['treeNode', 'api', 'hasCheckbox', 'hasControls', 'hasSingleSelect', 'hasCascadeSelect', 'controls', 'hasIcon', 'controlStyle'],
    data() {
        return {
            window: window,

            el: this.treeNode,

            checked: 0, // 没勾选 部分勾选 勾选
            open: false, // 打开子目录
            show: true, // 显示
            match: null, // 高亮
            selected: false
            //                className: '', //todo 控制样式
        };
    },
    watch: {
        checked: function(value) {
            // 向下
            if (value === 2 || value === 0) {
                (this.$refs.childNodes || []).forEach(n => {
                    n.treeNode.node.checked = value;
                });
            }
            // 向上
            if (this.treeNode.parent) {
                if (this.treeNode.parent.children.every(n => n.node.checked === 2)) {
                    if (this.hasCascadeSelect) {
                        this.treeNode.parent.node.checked = 2;
                    }
                } else if (this.treeNode.parent.children.every(n => !n.node.checked)) {
                    this.treeNode.parent.node.checked = 0;
                } else {
                    this.treeNode.parent.node.checked = 1;
                }
            }
        },
        open: function(value) {
            if (value && this.treeNode.parent) {
                this.treeNode.parent.node.open = value;
            }
            this.api.onToggle(this.treeNode, value);
        },
        show: function(value) {
            if (value && this.treeNode.parent) {
                this.treeNode.parent.node.show = value;
            }
        }
    },
    created() {
        ['show', 'checked', 'match', 'open'].map(key => {
            if (key in this.treeNode.node) {
                this[key] = this.treeNode.node[key];
            }
        });
        this.treeNode.node = this;
    },
    updated() {
        this.treeNode.node = this;
    },
    methods: {
        stopImmediatePropagation(e) {
            e.stopImmediatePropagation();
        },
        setChecked(e) {
            // 因为change迟于click触发所以改用click
            e.stopImmediatePropagation();
            let checked = e.currentTarget.checked;
            this.checked = checked ? 2 : 0;
        },
        select(e) {
            this.selected = this.hasSingleSelect(this.treeNode);
            this.api.selectNode(this.treeNode);
        },
        toggle() {
            this.open = !this.open;
        },
        toControl(func, e) {
            e.stopImmediatePropagation();
            func(this.treeNode, this.api);
        }
    }
};
</script>

<style lang="scss" scoped>
.tree-nodeitem {
    margin-top: -1px;
    &[data-itemid='0'] {
        & > .tree-item {
            display: none;
        }
    }
}

.el-icon-warning:after {
    content: '\E623';
    color: #f7ba2a;
    margin-left: 5px;
}
.el-icon-warning:before {
    content: '';
}

.tree-item {
    padding: 0 15px;
    line-height: 36px;
    border: 0 solid transparent;
    /*border-top-width: 1px;*/
    /*border-bottom-width: 1px;*/
    /*cursor: pointer;*/
    /*overflow: hidden;*/
    cursor: pointer;

    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;

    align-items: center;

    &.tree-item-match {
        background: #ebffe9;
        /*border-color: #d8fbd4;*/
    }
    /*&.selected,*/
    /*&:hover {*/
    /*background: #e4e8f1;*/
    /*!*border-color: #cbd9f9;*!*/
    /*}*/
    /*&:active {*/
    /*background: #c7d8ff;*/
    /*border-color: #cbd9f9;*/
    /*}*/
    .tree-hovercont {
        /*display: none;*/
        opacity: 0;
        /*float: right;*/
        white-space: nowrap;
        transition: all 0.2s;
    }
    &:hover .tree-hovercont {
        /*display: inline-block;*/
        opacity: 1;
    }
}

.tree-toggle,
.tree-itemcheckbox,
.tree-itemname {
    display: inline-block;
    vertical-align: middle;
}
.tree-itemname-icon {
    padding: 0 10px;
}

.tree-itemarrow {
    display: inline-block;
    width: 0;
    height: 0;
    margin: 4px;
    border: 6px solid transparent;
    border-left: 7px solid #99a9bf;
    vertical-align: middle;
    transition: transform 0.3s ease-in-out;
    transform-origin: 25% center;
    &.open {
        transform: rotate(90deg);
    }
    &.leaf {
        border-left-color: transparent;
    }
}

.tree-itemcheckbox {
    cursor: pointer;
    input {
        display: none;
    }
    span {
        position: relative;
        display: block;
        width: 18px;
        height: 18px;
        border: 1px solid #c0ccda;
        border-radius: 3px;
        transition: all 0.2s ease;

        &[data-checktype='1'],
        &[data-checktype='2'] {
            background-color: #20a0ff;
            border-color: #2e90fe;
        }
        &[data-checktype='1']:after {
            content: '';
            position: absolute;
            left: 3px;
            right: 3px;
            top: 47%;
            border-top: 2px solid #fff;
        }
        &[data-checktype='2']:after {
            content: '';
            position: absolute;
            left: 6px;
            top: 3px;
            border: 2px solid #fff;
            border-left: 0;
            border-top: 0;
            height: 8px;
            width: 4px;
            transform: rotate(45deg);
        }
    }
}

.tree-itemname {
    padding: 0 10px;
    font-size: 14px;

    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;

    background: inherit;
    /*text-overflow: ellipsis;*/

    /* Required for text-overflow to do anything */
    white-space: nowrap;
    /*overflow: hidden;*/
}

.tree-controlbtn {
    display: inline-block;
    padding: 8px 12px;
    // border: 1px solid #20a0ff;
    // color: #fff;
    color: #666;
    line-height: 1;
    font-size: 13px;
    font-weight: 100;
    // background-color: #20a0ff;
    & + .tree-controlbtn {
        border-left: 1px solid #bbb;
    }
}

.tree-childlist {
}
</style>
